module.exports = __webpack_public_path__ + "img/app-phone-3.d2dac53.svg";